/**
 * @generated SignedSource<<ff4eadd6308d4f706a83d9ced5c1d9de>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest, Mutation } from 'relay-runtime';
export type EventRequestDeclineInput = {
  preferredUserId: string;
  declinationReason: string;
  contactId: string;
};
export type requestDeclineRequestMutation$variables = {
  connections: ReadonlyArray<string>;
  id: string;
  input: EventRequestDeclineInput;
};
export type requestDeclineRequestMutation$data = {
  readonly declineEventRequest: {
    readonly id: string;
  };
};
export type requestDeclineRequestMutation = {
  variables: requestDeclineRequestMutation$variables;
  response: requestDeclineRequestMutation$data;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "connections"
  },
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "id"
  },
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "input"
  }
],
v1 = [
  {
    "kind": "Variable",
    "name": "id",
    "variableName": "id"
  },
  {
    "kind": "Variable",
    "name": "input",
    "variableName": "input"
  }
],
v2 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
};
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "requestDeclineRequestMutation",
    "selections": [
      {
        "alias": null,
        "args": (v1/*: any*/),
        "concreteType": "EventRequestDeletePayload",
        "kind": "LinkedField",
        "name": "declineEventRequest",
        "plural": false,
        "selections": [
          (v2/*: any*/)
        ],
        "storageKey": null
      }
    ],
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "requestDeclineRequestMutation",
    "selections": [
      {
        "alias": null,
        "args": (v1/*: any*/),
        "concreteType": "EventRequestDeletePayload",
        "kind": "LinkedField",
        "name": "declineEventRequest",
        "plural": false,
        "selections": [
          (v2/*: any*/),
          {
            "alias": null,
            "args": null,
            "filters": null,
            "handle": "deleteEdge",
            "key": "",
            "kind": "ScalarHandle",
            "name": "id",
            "handleArgs": [
              {
                "kind": "Variable",
                "name": "connections",
                "variableName": "connections"
              }
            ]
          }
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "cacheID": "34bee794379534b87c23eaecaeb3edce",
    "id": null,
    "metadata": {},
    "name": "requestDeclineRequestMutation",
    "operationKind": "mutation",
    "text": "mutation requestDeclineRequestMutation(\n  $id: ID!\n  $input: EventRequestDeclineInput!\n) {\n  declineEventRequest(id: $id, input: $input) {\n    id\n  }\n}\n"
  }
};
})();

(node as any).hash = "50e746140ab1e9aa6c61f46089ac4655";

export default node;
